/** Opzioni filtri allineate allo schema Strapi `manuale-gioco`. */

export const TIPOLOGIE = [
  { value: 'fisico', label: 'Fisico' },
  { value: 'tavolo', label: 'Tavolo' },
  { value: 'ruolo', label: 'Ruolo' },
  { value: 'educativo', label: 'Educativo' },
  { value: 'ibrido', label: 'Ibrido' },
];

/** `colorScheme` Chakra per badge / accenti per tipologia */
export const TIPOLOGIA_COLOR_SCHEME = {
  fisico: 'orange',
  tavolo: 'purple',
  ruolo: 'pink',
  educativo: 'green',
  ibrido: 'cyan',
};

/** Colore bordo card lista (token Chakra): una tonalità distinta per tipologia */
export const TIPOLOGIA_CARD_BORDER_COLOR = {
  fisico: 'orange.400',
  tavolo: 'purple.500',
  ruolo: 'pink.500',
  educativo: 'green.500',
  ibrido: 'cyan.500',
};

export const COMPETITIVITA = [
  { value: 'cooperativo', label: 'Cooperativo' },
  { value: 'competitivo', label: 'Competitivo' },
  { value: 'misto', label: 'Misto' },
];

export const LIVELLI = [1, 2, 3, 4, 5].map((n) => ({
  value: `livello_${n}`,
  label: '\u2605'.repeat(n) + '\u2606'.repeat(5 - n),
}));

export const CATEGORIE_GIOCO = [
  'Movimento e corsa',
  'Palla e lancio',
  'Strategia e ruoli',
  'Conoscenza e gruppo',
  'Cooperazione',
  'Staffette e prove',
  "Giochi d'acqua",
  'Giochi da interno',
  'Giochi a squadre',
  'Grandi giochi',
];

export const MECCANICHE_GIOCO = [
  'Inseguimento',
  'Eliminazione',
  'Conquista base',
  'Prigionieri',
  'Lancio',
  'Memoria',
  'Ruoli',
  'Raccolta oggetti',
  'Tutti contro tutti',
  'Cooperazione',
  'Ascolto',
  'Strategia',
];

export const FASCE_ETA = [
  'Infanzia (3–5 anni)',
  'Elementari (6–10 anni)',
  'Medie (11–13 anni)',
  'Superiori (14–18 anni)',
  'Famiglie',
  'Animatori',
];

/**
 * Valore `fasceEta` da Strapi (array, JSON string o CSV).
 * @param {unknown} val
 * @returns {string[]}
 */
function parseFasceEtaList(val) {
  if (val == null) return [];
  if (Array.isArray(val))
    return val
      .map(String)
      .map((s) => s.trim())
      .filter(Boolean);
  if (typeof val === 'string') {
    const t = val.trim();
    if (!t) return [];
    try {
      const j = JSON.parse(t);
      if (Array.isArray(j))
        return j
          .map(String)
          .map((s) => s.trim())
          .filter(Boolean);
    } catch {
      /* ignore */
    }
    return t
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [];
}

/**
 * Età minima in anni da una singola etichetta fascia (come in `FASCE_ETA`).
 * @param {string} label
 * @returns {number | null}
 */
function fasciaEtaLabelToMinYears(label) {
  const s = String(label).trim();
  if (!s) return null;
  const m = s.match(/\((\d+)\D+?(\d+)\s*anni\)/i);
  if (m) return parseInt(m[1], 10);
  if (s === 'Famiglie') return 3;
  if (s === 'Animatori') return 16;
  return null;
}

/**
 * Età minima (anni) dalle fasce selezionate: minimo tra i minimi di ogni fascia.
 * @param {unknown} val
 * @returns {number | null}
 */
export function etaMinDaFasceEta(val) {
  const ages = parseFasceEtaList(val)
    .map(fasciaEtaLabelToMinYears)
    .filter((n) => n != null && Number.isFinite(n));
  if (!ages.length) return null;
  return Math.min(...ages);
}

export const SPAZI_GIOCO = [
  'Aperto',
  'Chiuso',
  'Palestra',
  'Bosco/parco',
  'Piccolo spazio',
  'Grande spazio',
  'Corridoio',
  'Campo rettangolare',
  'Cerchio',
];

export const OBIETTIVI_EDUCATIVI = [
  'Collaborazione',
  'Fiducia',
  'Conoscenza',
  'Problem solving',
  'Strategia',
  'Coordinazione',
  'Inclusione',
  'Gestione frustrazione',
  'Leadership',
  'Creatività',
];

export const MATERIALI = [
  'Pallone',
  'Palla da pallavolo',
  'Corde',
  'Cinesini',
  'Fazzoletti',
  'Coni',
  'Cerchi',
  'Gilet',
  'Fischietto',
  'Carta e penne',
  'Aste',
  'Teloni',
  'Secchi',
  'Spugne',
  'Borraccia',
  'Sacco a pelo',
  'Materassino',
  'Rete',
  'Bastoni da trekking',
  'Orologio',
  'Corda elastica',
  'Frisbee',
  'Corda per saltare',
  'Casette / birilli',
];
